import React, { memo } from "react";
import { Handle, Position } from "@xyflow/react";
import { Campaign } from "@mui/icons-material";
import NodeWrapper from "./NodeWrapper";

const ACTION_LABELS = {
  add: "Adicionar",
  remove: "Remover",
};

const CampaignProNode = memo(({ id, data, isConnectable, selected }) => {
  const action = data?.action;
  const listName = data?.listName || data?.list?.name;
  const actionLabel = ACTION_LABELS[action] || action;
  const isRemove = action === "remove";

  return (
    <NodeWrapper
      id={id}
      data={data}
      icon={<Campaign />}
      title="Campanha PRO"
      color="#215e97"
      bgColor="#F0F4FF"
      isConnectable={isConnectable}
      selected={selected}
    >
      {action && (
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 4,
            padding: "2px 8px",
            borderRadius: 4,
            fontSize: 10,
            fontWeight: 700,
            textTransform: "uppercase",
            letterSpacing: "0.03em",
            backgroundColor: isRemove ? "#FDECEA" : "#E8F5E9",
            color: isRemove ? "#c62828" : "#2e7d32",
            marginBottom: 6,
          }}
        >
          {actionLabel}
        </div>
      )}
      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 6,
          padding: "4px 10px",
          borderRadius: 20,
          fontSize: 11,
          fontWeight: 600,
          backgroundColor: listName ? "#E8F0FE" : "#f5f5f5",
          color: listName ? "#215e97" : "#999",
          border: `1px solid ${listName ? "#215e9730" : "#e0e0e0"}`,
          maxWidth: "100%",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        <Campaign style={{ fontSize: 13, color: listName ? "#215e97" : "#bbb" }} />
        {listName || "Nenhuma lista"}
      </div>
    </NodeWrapper>
  );
});

CampaignProNode.displayName = "CampaignProNode";
export default CampaignProNode;
